// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__O0lBB","content":"Layout_content__LXFqm"};